import {Directive, EventEmitter, HostBinding, Input, Output} from "@angular/core";

@Directive()
export abstract class FUIAbstractToggle {
    private _toggled: boolean;
    @Output() public toggled$: EventEmitter<boolean>;

    constructor() {
        this.toggled$ = new EventEmitter<boolean>();
    }

    /**
     *
     * @returns {boolean}
     */
    get toggled(): boolean{
        return this._toggled;
    }

    /**
     *
     * @param {boolean} toggled
     */
    @HostBinding("class.toggled")
    @Input()
    set toggled(toggled: boolean){
        this._toggled = toggled;
        this.toggled$.emit(this.toggled);
    }
}
